let elements = {
  // mainImage: {
  //   imagePath: 'games/page002_game1/img/bcg.png',
  //   pos: {
  //     y: 294,
  //     x: 630,
  //   },
  //   height: 600,
  // },
  // withoutCheck: true,
  imageHighlight: true,
  noClose: true,
  imageHighlightColor: 'red',
  images: [
    {
      correct: true,
      src: 'games/page002_game5/img/01.png',
      // imageHighlightColor: 'green',
      pos: {
        y: 200,
        x: 200,
      },
      images: [
        {
          src: 'games/page002_game5/img/tru.png',
          pos: {
            y: 367,
            x: 440,
          },
          width: 100,
          height: 100,
        },
      ],
      width: 300,
      audio: {
        src: 'games/page002_game5/audio/z2c5-3.mp3',
        volume: 1,
      },
    },
    {
      correct: true,
      src: 'games/page002_game5/img/02.png',
      // imageHighlightColor: 'green',
      pos: {
        y: 700,
        x: 780,
      },
      images: [
        {
          src: 'games/page002_game5/img/tru.png',
          pos: {
            y: 585,
            x: 1060,
          },
          width: 100,
          height: 100,
        },
      ],
      width: 440,
      audio: {
        src: 'games/page002_game5/audio/z2c5-2.mp3',
        volume: 1,
      },
    },
    {
      correct: true,
      src: 'games/page002_game5/img/03.png',
      // imageHighlightColor: 'green',
      pos: {
        y: 220,
        x: 1400,
      },
      images: [
        {
          src: 'games/page002_game5/img/tru.png',
          pos: {
            y: 300,
            x: 1335,
          },
          width: 100,
          height: 100,
        },
      ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Jednostka centralna</p>',
      width: 450,
      background: 'red',
      audio: {
        src: 'games/page002_game5/audio/z2c5-1.mp3',
        volume: 1,
      },
    },
    {
      correct: true,
      src: 'games/page002_game5/img/04.png',
      // imageHighlightColor: 'green',
      pos: {
        y: 700,
        x: 270,
      },
      images: [
        {
          src: 'games/page002_game5/img/tru.png',
          pos: {
            y: 707,
            x: 350,
          },
          width: 100,
          height: 100,
        },
      ],
      width: 140,
      audio: {
        src: 'games/page002_game5/audio/z2c5-6.mp3',
        volume: 1,
      },
    },
    {
      src: 'games/page002_game5/img/05.png',
      // imageHighlightColor: 'red',
      pos: {
        y: 210,
        x: 841,
      },
      images: [
        {
          src: 'games/page002_game5/img/war.png',
          pos: {
            y: 277,
            x: 990,
          },
          width: 100,
          height: 100,
        },
      ],
      width: 220,
      audio: {
        src: 'games/page002_game5/audio/z2c5-4.mp3',
        volume: 1,
      },
    },
    {
      src: 'games/page002_game5/img/06.png',
      // imageHighlightColor: 'red',
      pos: {
        y: 690,
        x: 1515,
      },
      images: [
        {
          src: 'games/page002_game5/img/war.png',
          pos: {
            y: 727,
            x: 1600,
          },
          width: 100,
          height: 100,
        },
      ],
      width: 150,
      audio: {
        src: 'games/page002_game5/audio/z2c5-5.mp3',
        volume: 1,
      },
    },
  ],
};

export default elements;
